import { styled } from '@mui/material/styles';
import { ReactComponent as Icon } from '@/assets/image.svg';
import classNames from 'classnames';

export const ImageIcon = styled(
	({ className }: { className?: string }) => (
		<Icon className={classNames('icon', 'image', className)} />
	),
	{
		target: 'ImageIcon-root',
		label: 'ImageIcon',
	},
)({});
